import { DropdownWUT } from '@wix/form-fields/viewer-wut';

export default DropdownWUT;
